import { gql } from '@apollo/client';

export const GET_AD_ACCOUNTS_BY_ORG_ID = gql`
  query getAllAdAccountsByOrgId($paginationOptions: PaginationOptions, $organizationId: ID!) {
    getAllAdAccountsByOrgId(paginationOptions: $paginationOptions, organizationId: $organizationId) {
      edges {
        node {
          id
          name
          accountsApprovedForTerms
          isBaymaxEnabled
          brand {
            id
            name
          }
        }
      }
      total
    }
  }
`;
